import {defineStore} from 'pinia';
import popupUtil from '@/commons/popupUtil';
import {ModuleOrderPopupStore} from '../moduleConst';
import {showConfirmValidate} from '@/commons/globalMessage';

/**
 * Store ...
 */
export const useOrderPopupStore = defineStore(ModuleOrderPopupStore, {
  state: () => ({
    orderNumbers: {
      DataMantainance: 1,
      ExpiredNotification: 2,
      NoticeUpdateCircularTT23: 3,
      NpsServeyPopup: 4,
      IsmacNotiPopup: 5,
      ConvertDesktopSuccess: 6,
      BackupRestoreProcessPopupX: 7
    },
    types: {
      // lowercase tên thuộc tính: popup, showconfirmvalidate
      popup: {
        name: 'popup',
        showFn: 'showPopup'
      },
      showconfirmvalidate: {
        name: 'showconfirmvalidate',
        showFn: 'showConfirmValidateX'
      }
    },
    defaultOrder: 1000,
    stack: [],
    endPages: ['mainlayout', 'topnav', 'ismac'],
    flagPages: [],
  }),
  actions: {
    /**
     * @param {string} name 
     * @param {string} type popup / showconfirmvalidate
     * @param {{name: string, params: Object.<string, any>, ignoreCheckPermission: bool}|{message: string, title: string, customButton: Object.<string, any>, width: number, fnCallback: function}} args 
     */
    addElement(name, type, args){
      const me = this, {orderNumbers, defaultOrder, stack, valuesOfTypes} = me;
      if(type && typeof(type) == 'string' && valuesOfTypes.includes(type.toLowerCase())){
        // type = popup               -> args: {name, params, ignoreCheckPermission, attrs}
        // type = showconfirmvalidate -> args: {message, title, customButton, width, fnCallback}
        me.$state.stack.push({
          name: name,
          orderNumber: orderNumbers[name] ?? defaultOrder + stack.length + 1,
          type: type.toLowerCase(), args: args
        });
      } else {
        throw `[OrderPopupStore/addElement] [name = ${name}] <type> must includes [${valuesOfTypes.join(', ')}]`;
      }
    },

    async showNow(endPageName){
      const me = this, {endPages, types, stack} = me;

      // Khi nào onmouted của cả MainLayout và TopNav xong thì mới thực hiện show lần lượt các popup
      if(endPageName && (endPageName = endPageName.toLowerCase()) && endPages.includes(endPageName) && !me.$state.flagPages.includes(endPageName)){
        me.$state.flagPages.push(endPageName);
      } else {
        throw `[OrderPopupStore/showNow] [endPageName = ${endPageName ?? '_empty'}] <endPageName> must includes [${valueOfEndPages}]`;
      }

      if(me.$state.flagPages.distinctKey().length == endPages.length){
        me.$state.stack = me.$state.stack.sortObject('orderNumber');
        const orderNumber = 0, popup = Array.isArray(stack) && stack.length > 0 ? stack[orderNumber] : {};
  
        popup.type && await me[types[popup.type].showFn](orderNumber);
      }

    },

    async showPopup(orderNumber){
      const me = this, stack = me.$state.stack, popup = stack[orderNumber], {name} = popup;
      let {params, ignoreCheckPermission, attrs} = popup.args ?? {}, isContinue = stack.length > orderNumber + 1;
      
      params = !params ? {} : params;
      params.fromOrderPopupStore = isContinue ? { order: orderNumber } : null;

      await popupUtil.show(name, params, ignoreCheckPermission, attrs);
    },

    async showConfirmValidateX(orderNumber){
      const me = this, stack = me.$state.stack, popup = stack[orderNumber], isContinue = stack.length > orderNumber + 1;
      let {message, title, customButton, width, fnCallback} = popup.args ?? {};

      var confirm = await showConfirmValidate(message, title, customButton, width);
      if(fnCallback && typeof fnCallback == 'function'){
        fnCallback[Symbol.toStringTag] == 'AsyncFunction' ? await fnCallback(confirm) : fnCallback(confirm);
        isContinue && await me.nextShow({order: orderNumber});
      }
    },

    async nextShow({order}){
      const me = this, 
            curOrder = order,
            {stack, types} = me.$state,
            isNext = Number.isInteger(curOrder) && curOrder + 1 < stack.length,
            nextPopup = isNext ? stack[curOrder + 1] : null;

      nextPopup && nextPopup.type && await me[types[nextPopup.type].showFn](curOrder + 1);
    },
  },
  getters: {
    valuesOfTypes(){
      let {types} = this.$state, vals = [];
      for(var prop in types){ vals.push(types[prop].name); }
      return vals;
    },
    valueOfEndPages(){
      return this.$state.endPages.join(',');
    }
  },
});
